export { default } from './ListItemIcon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemIcon/index.js
// module id = 340
// module chunks = 0